import Unit from './index';

export default class ProcurementProductUnit extends Unit {

    list = (search, cbSuccess, cbError) => {
        this.post('/procurementproduct/list', { search: search }, cbSuccess, cbError);
    }

    getProduct = (productId, cbSuccess, cbError) => {
        this.get('/procurementproduct/'+productId, cbSuccess, cbError);
    }

    create = (body, cbSuccess, cbError) => {
        this.post('/procurementproduct', body, cbSuccess, cbError);
    }

    update = (data, cbSuccess, cbError) => {
        this.put('/procurementproduct', data, cbSuccess, cbError);
    }

}



